Vendd.Scripts.load(function () {
    'use strict';
    var $form = $('.x-account-edit-form'), form, $submitButton, formData, ef;

    if ($form.length < 1)
        return;

    var model = null;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    var validationOptions = {}, initialValidation = false;

    var loyaltyMemberCardNumberIsValid = true;

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.update = function () {
        var html = Vendd.Handlebars.parse("accountEditForm_A", model);
        form.bind(html);
        form.initFormData();
    };

    form.bind = function (html) {
        $form.html(html);

        //add required validations
        $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
            var inputName = $(el).attr('name');
            validationOptions[inputName] = { required: inputName + '-required' };
        });

        //add email validation
        if ($('input[name="email"]', $form).length > 0) {
            validationOptions.email = validationOptions.email || {};
            validationOptions.email = { ...validationOptions.email, ...{ isEmail: 'email-invalid' } };
        }

        //add phone validation
        if ($('input[name="phone"]', $form).length > 0) {
            validationOptions.phone = validationOptions.phone || {};
            if (venddProjectConfigs.phoneLocalizationEnabled) {
                validationOptions.phone = { ...validationOptions.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } } };
            } else {
                if (venddProjectConfigs.Account.RegexPhoneValidation) {
                    validationOptions.phone = { ...validationOptions.phone, ...{ isRegexPhone: { validator: 'phone-invalid', config: { regex: venddProjectConfigs.Account.RegexPhoneValue } } } };
                } else {
                    validationOptions.phone = { ...validationOptions.phone, ...{ isPhoneNumber: 'phone-invalid' } };
                }
            }
        }

        //add mobile validation
        if ($('input[name="mobilephone"]', $form).length > 0) {
            validationOptions.mobilephone = validationOptions.mobilephone || {};
            if (venddProjectConfigs.phoneLocalizationEnabled) {
                validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isValidPhoneLocalized: { validator: 'mobilephone-invalid', config: { type: 'mobile' } } } };
            } else {
                if (venddProjectConfigs.Account.RegexMobileValidation) {
                    validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isRegexMobile: { validator: 'mobilephone-invalid', config: { regex: venddProjectConfigs.Account.RegexMobileValue } } } };
                } else {
                    validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isPhoneNumber: 'mobilephone-invalid' } };
                }
            }
        }

        //add social security number validation
        if (model.SocialSecurityNumberIsEnabled && venddProjectConfigs && venddProjectConfigs.Account && venddProjectConfigs.Account.EditForm && venddProjectConfigs.Account.EditForm.ValidateSocialSecurityNumber === true) {
            validationOptions.socialSecurityNumber = { isSocialSecurityNumber: 'socialSecurityNumber-invalid' };
        }

        $.fn.validationEngine.validations.passwordStrength = Vendd.Validations.passwordStrength;

        $form.validationEngine(validationOptions);
        ef = $form.data('validationEngine');

        $(".js-datepicker", $form).datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: "-100:+0",
            maxDate: "0"
        });

        var receiveInvoice = $('.form-row.eInvoice').data('einvoice');
        $("input:radio[name='eInvoice']").removeAttr('checked');

        if (receiveInvoice === true) {
            $("input:radio[value='true']").attr('checked', 'checked');
        } else if (receiveInvoice === false) {
            $("input:radio[value='false']").attr('checked', 'checked');
        } else {
            $("input:radio[value='null']").attr('checked', 'checked');
        }

        if (model.LoyaltyMemberCardNumberIsEnabled) {
            $form.on('blur', 'input[name="loyaltyMemberCardNumber"]', function (e) {
                var loyaltyMemberCardNumber = $(this).val();
                var $formRow = $(this).closest('.form-row');
                loyaltyMemberCardNumber = loyaltyMemberCardNumber.replace(/\s/g, '');
                $(this).val(loyaltyMemberCardNumber);
                if (loyaltyMemberCardNumber == '') {
                    $('.loyaltyMemberCardNumber-invalid', $formRow).hide();
                    $formRow.removeClass('with-error');
                    loyaltyMemberCardNumberIsValid = true;
                } else {
                    //omit script tag before ajax call
                    loyaltyMemberCardNumber = omitScriptTag(loyaltyMemberCardNumber);

                    $('.js-submit-button', $form).attr('disabled', 'disabled'); 
                    Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetMemberByLoyaltyNumber(loyaltyMemberCardNumber));
                }
            });
        }

        if (venddProjectConfigs.phoneLocalizationEnabled) {            
            if ($('input[name="phone"]', $form).length > 0) {
                $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                    formData.phone = $(this).val();
                    ef = $form.data('validationEngine');
                    ef.validate('phone');
                });
            }
            if ($('input[name="mobilephone"]', $form).length > 0) {
                $('input[name="mobilephone"]', $form).get(0).addEventListener("countrychange", function () {
                    formData.mobile = $(this).val();
                    ef = $form.data('validationEngine');
                    ef.validate('mobilephone');
                });
            }
        }

        $('.success-form', $form).children().hide();
        $('.error-form', $form).children().hide();

    };

    form.initFormData = function () {
        formData = {
            firstName: model.FirstName,
            lastName: model.LastName,
            userName: model.UserName,
            email: model.Email,
            oldPassword: model.OldPassword,
            password: model.Password,
            passwordConfirmation: model.PasswordConfirmation,
            newsletter: model.Newsletter,
            phone: model.Phones,
            mobilephone: model.MobilePhone,
            socialSecurityNumber: model.SocialSecurityNumber,
            birthDate: model.BirthDate,
            isLoyaltyMember: model.IsLoyaltyMember,
            loyaltyRequest: model.LoyaltyRequest,
            receiveEinvoice: model.ReceiveEinvoice,
            loyaltyMemberId: model.LoyaltyMemberId,
            resellerDisplayedPrice: model.ResellerDisplayedPrice,
            loyaltyMemberCardNumber: model.LoyaltyMemberCardNumber
        };
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        $('.js-success', $form).show();
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;

        if (response.code === "AccountEdit_EmailExists") {
            $('.js-error', $form).hide();
            $('.js-wrong-password', $form).hide();
            $('.js-validation-error', $form).hide();
            $('.js-exists', $form).show();

        } else if (response.code === "AccountEdit_WrongPassword") {
            $('.js-error', $form).hide();
            $('.js-validation-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-wrong-password', $form).show();

        } else if (response.code === "AccountEdit_ValidationError") {
            $('.js-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-wrong-password', $form).hide();
            $('.js-validation-error', $form).show();

        } else {
            $('.js-exists', $form).hide();
            $('.js-wrong-password', $form).hide();
            $('.js-validation-error', $form).hide();
            $('.js-error', $form).show();
        }
    };

    form.updatePasswordBar = function (value) {
        var score = Vendd.Helpers.textStrength(value);

        var $passwordStrength = $('#chkPassLabel, #chkPassText');

        $passwordStrength.removeClass(function (i, css) {
            return (css.match(/(^|\s)level\S+/g) || []).join(' ');
        }).addClass('level' + score);
    };

    $form.on('click', '.js-submit-button', function () {

        if (model.LoyaltyMemberCardNumberIsEnabled && !loyaltyMemberCardNumberIsValid)
            return;

        $('.form-msg-error', $form).hide();
        $('.js-success', $form).hide();

        var val1 = ef.validate();

        if (val1) {
            formData.newsletter = $('#chk_NewsletterSubscription').prop("checked");

            if (model.LoyaltyClub9Enabled)
                formData.loyaltyRequest = $('#loyaltyRequest').prop("checked");

            if (model.IsReseller)
                formData.resellerDisplayedPrice = $('#chk_ResellerDisplayedPrice').prop("checked");    

            var einvoiceVal = $("input:radio[name='eInvoice']:checked").val();

            if (einvoiceVal === "true") {
                formData.receiveEinvoice = true;
            } else if (einvoiceVal === "false") {
                formData.receiveEinvoice = false;
            } else {
                formData.receiveEinvoice = null;
            }

            $('input[name]:not([type="checkbox"]):not([type="radio"])', $form).each(function () {
                formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
            });

            form.loading(true);
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.EditUser(
                formData.firstName,
                formData.lastName,
                formData.userName,
                formData.email,
                formData.oldPassword,
                formData.password,
                formData.passwordConfirmation,
                formData.newsletter,
                formData.phone,
                formData.mobilephone,
                formData.socialSecurityNumber,
                formData.birthDate,
                formData.isLoyaltyMember,
                formData.loyaltyRequest,
                formData.receiveEinvoice,
                formData.loyaltyMemberId,
                formData.resellerDisplayedPrice,
                formData.loyaltyMemberCardNumber
            ));
        }

        initialValidation = true;
    });

    $form.on('click', '.js-password-reveal', function (e) {
        e.preventDefault();
        if ($(this).hasClass('shown')) {
            $(this).removeClass('shown').siblings('input').prop('type', 'password');
        } else {
            $(this).addClass('shown').siblings('input').prop('type', 'text');
        }
    });

    $form.on('keyup', 'input[name]', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        }

        var $this = $(this);
        var fieldName = $this.attr('name');

        if (fieldName === "password") {
            form.updatePasswordBar($this.val());
        }

        formData[fieldName] = $this.val();
        ef.validate(fieldName);
    });

    $form.on('blur', 'input[name]', function (e) {
        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "phone") {
                ef.validateField("phone");
            }

            if ($(this).attr('name') === "mobilephone") {
                ef.validateField("mobilephone");
            }
        }
    });

    $form.on('click', '.js-change-password', function (e) {
        $('.js-change-password-container', $form).toggleClass('show');

        if ($(this).is(":checked")) {          
            ef.addField({
                oldPassword: {
                    required: 'oldPassword-required',
                },
                password: {
                    required: 'password-required',
                    passwordStrength: {
                        validator: 'password-weak',
                        config: {
                            limit: $form.data('pwdstrength')
                        }
                    }
                },
                passwordConfirmation: {
                    required: 'passwordConfirmation-required',
                    match: {
                        validator: 'passwordConfirmation-match',
                        matchField: 'password'
                    }
                }
            });
            ef.enable(["oldPassword", "password", "passwordConfirmation"]);
        } else {
            ef.disable(["oldPassword", "password", "passwordConfirmation"]);
            ef.removeField(["oldPassword", "password", "passwordConfirmation"]);
            $('input[name = "oldPassword"], input[name = "password"], input[name = "passwordConfirmation"]').val("");
            form.updatePasswordBar("");
        }

    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetMemberByLoyaltyNumberSuccess, form, function (envelope) {
        var data = envelope.message.data.model.data;
        if (data.ErrorCode) {
            $('.loyaltyMemberCardNumber-invalid', $form).show().closest('.form-row').addClass('with-error');
            loyaltyMemberCardNumberIsValid = false;
        }
        else {
            $('.loyaltyMemberCardNumber-invalid', $form).hide().closest('.form-row').removeClass('with-error');
            loyaltyMemberCardNumberIsValid = true;
        }
        $('.js-submit-button', $form).removeAttr('disabled');
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetMemberByLoyaltyNumberFailed, form, function (envelope) {
        var message = envelope.message.data.model.message;
        toastr.error(message);
        loyaltyMemberCardNumberIsValid = false;
        $('.js-submit-button', $form).removeAttr('disabled');
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditUserSuccess, form, function (response) {
        form.onSuccess(response);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditUserFailed, form, function (response) {
        form.onFailure(response);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetUserAccountSuccess, form, function (envelope) {
        model = envelope.message.data.model;
        form.update(); 

        if (venddProjectConfigs.phoneLocalizationEnabled) {
            //call public function for phone localization
            initPhoneLocalization();
        }
    });

    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetUserAccount());

});
